var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColXlOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 41,
    viewBox: "0 0 3 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.656 0H1.40317C0.70789 0 0.144249 0.4515 0.144249 1.00845V39.9915C0.144249 40.5485 0.70789 41 1.40317 41H1.656C2.35128 41 2.91491 40.5485 2.91491 39.9915V1.00845C2.91491 0.4515 2.35128 0 1.656 0Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColXlOwner);
export default __webpack_public_path__ + "static/media/col_xl_owner.774dc37135199ce0a2b1e0e416cf5dca.svg";
export { ForwardRef as ReactComponent };